/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { ListFilters } from 'config/constants/invoice';
import { mapFilterParams } from './utils';

export const invoiceListQueryStringMapper = mapFilterParams(Object.values(ListFilters));
